import React from 'react';
import PropTypes from 'prop-types';
import { Grid, TextField, MenuItem, Chip, Box } from '@mui/material';

const renderStatusValue = (value) => {
  return value === '' ? 'Select Status' : value;
};

const EditOnboardingSteps = ({ manufacturer, editingAccount, setEditingAccount, getStepsForManufacturer, getStatusesForManufacturer, getStatusColor }) => {
  return getStepsForManufacturer(manufacturer).filter(step => step.key !== 'credentials' && step.key !== 'goLiveDate' && step.key !== 'evokePortalName').map((step) => {
    const handleStepChange = (e) => {
      const updatedData = {
        ...editingAccount.manufacturerData,
        [manufacturer]: {
          ...editingAccount.manufacturerData[manufacturer],
          [step.key]: e.target.value
        }
      };
      setEditingAccount(prev => ({ ...prev, manufacturerData: updatedData }));
    };
    
    return (
      <Grid
        key={step.key}
        size={{
          xs: 12,
          md: 4
        }}>
        <TextField
          select
          fullWidth
          label={
            (step.key === 'credentialsProvided' || step.key === 'hl7Form') ? (
              <Box component="span" sx={{ display: 'flex', alignItems: 'center', gap: 0.5 }}>
                {step.label}
                <Chip 
                  label="Evoke" 
                  size="small" 
                  color="primary" 
                  variant="outlined"
                  sx={{ height: 16, fontSize: '0.65rem', fontWeight: 600 }}
                />
              </Box>
            ) : step.label
          }
          value={editingAccount.manufacturerData[manufacturer]?.[step.key] || ''}
          onChange={handleStepChange}
          size="small"
          slotProps={{
            select: {
              displayEmpty: true,
              renderValue: renderStatusValue
            },

            inputLabel: { shrink: true }
          }}>
          {getStatusesForManufacturer(manufacturer).map(status => (
            <MenuItem key={status} value={status}>
              <Chip 
                label={status} 
                color={getStatusColor(status)} 
                size="small" 
              />
            </MenuItem>
          ))}
        </TextField>
      </Grid>
    );
  });
};

EditOnboardingSteps.propTypes = {
  manufacturer: PropTypes.string.isRequired,
  editingAccount: PropTypes.object.isRequired,
  setEditingAccount: PropTypes.func.isRequired,
  getStepsForManufacturer: PropTypes.func.isRequired,
  getStatusesForManufacturer: PropTypes.func.isRequired,
  getStatusColor: PropTypes.func.isRequired
};

export default EditOnboardingSteps;